import { toMillis } from "./shiftMetricsEngine";
import { getCanonicalShiftStatus } from "../core/shifts/shiftLifecycle";

export function buildFacilityFinancialMetrics(
  shifts = [],
  { facilityRates = {} } = {}
) {
  let projectedHours = 0;
  let actualHours = 0;

  let projectedSpend = 0;
  let actualSpend = 0;
  let billingDataComplete = shifts.length > 0;

  for (const shift of shifts) {
    const status = getCanonicalShiftStatus(shift);
    if (["cancelled", "canceled"].includes(status)) continue;
    const startMs = toMillis(
      shift.startTime || shift.start
    );

    const endMs = toMillis(
      shift.endTime || shift.end
    );

    if (
      !Number.isFinite(startMs) ||
      !Number.isFinite(endMs) ||
      endMs <= startMs
    ) {
      billingDataComplete = false;
      continue;
    }

    const hours = (endMs - startMs) / 3600000;

    const role = String(
      shift.role ||
      shift.requiredPosition ||
      ""
    ).toUpperCase();

    // Keep the existing billing inputs/classification. Missing inputs are not
    // evidence of a zero charge and must not be displayed as confirmed totals.
    const suppliedRates = [shift.billRate, shift.billingRate,
      shift?.rates?.billRate, facilityRates?.[role]?.billRate];
    const typedRate = value => typeof value === 'number' ||
      (typeof value === 'string' && value.trim() !== '');
    const selectedRate = suppliedRates.find(value => Boolean(Number(value))) ??
      suppliedRates.find(value => typedRate(value) && Number(value) === 0);
    if (!typedRate(selectedRate) || !Number.isFinite(Number(selectedRate)) || Number(selectedRate) < 0) {
      billingDataComplete = false;
    }

    const billRate =
      Number(shift.billRate) ||
      Number(shift.billingRate) ||
      Number(shift?.rates?.billRate) ||
      Number(facilityRates?.[role]?.billRate) ||
      0;

    projectedHours += hours;
    projectedSpend += hours * billRate;



    if (
      status === "completed" ||
      status === "done" ||
      status === "ended"
    ) {
      const completedMs = toMillis(shift.completedAt || shift.endTime || shift.end);
      if (Number.isFinite(completedMs) && completedMs > startMs) {
        const completedHours = (completedMs - startMs) / 3600000;
        actualHours += completedHours;
        actualSpend += completedHours * billRate;
      }
    }
  }

  return {
    billingDataComplete,
    projectedHours,
    actualHours,
    projectedSpend,
    actualSpend,
    variance: projectedSpend - actualSpend,
  };
}
